export default "__VITE_ASSET__B8tu$b_u__"